module.exports = __webpack_public_path__ + "img/3e0efd994f464828abad3a6cf32e75c0.00b818c2.png";